module.exports = __webpack_public_path__ + "static/media/saffron2_preview.a5c027c2.jpg";